/**
 * 昆仑山版本信息
 */
import React, { Fragment } from 'react';
import { Descriptions, Divider } from 'antd';
import { klsVersionInfoFileds, KlsVersionInfoFiledsInterface, KlsVersionFiledsInterface, lxVersionINfoFileds } from '@/constants/klsVersionInfo';

interface KlsVersionInfoProps {
  data: { [key: string]: string | number };
  isLingChang?: boolean
}
const KlsVersionInfo = (props: KlsVersionInfoProps) => {
  const { data, isLingChang} = props;
  const fileds = isLingChang ? lxVersionINfoFileds : klsVersionInfoFileds
  return (
    <div>
      {fileds.map((item: KlsVersionInfoFiledsInterface) => (
        <Fragment key={item.title}>
          <Divider orientation="left">{item.title}</Divider>
          <Descriptions>
            {item.children.map((item1: KlsVersionFiledsInterface) => (
              <Descriptions.Item
                label={item1.title}
                key={item1.field}
              >
                {data?.[item1.field]}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </Fragment>
      ))}
    </div>
  )
}

export default KlsVersionInfo;